export const TYPE_WIDTH = 2
export const LEDGER_ENTRY_WIDTH = 2
export const TRANSACTION_TYPE_WIDTH = 2
export const TRANSACTION_RESULT_WIDTH = 1
